<template>
  <v-dialog
    top
    v-model="internalOpen"
    max-width="480"
    @click:outside="handleCancel"
    @keydown.esc="handleCancel"
  >
    <v-card v-if="application">
      <v-card-title class="breakword error--text">
        Permanently delete this stylist?
      </v-card-title>
      <v-card-text>
        <p class="mb-3">
          This cannot be undone. The stylist will be able to register again with
          the same email after deletion.
        </p>
        <p class="mb-1">
          <strong>Name:</strong>
          {{ application.firstName }} {{ application.lastName }}
        </p>
        <p class="mb-1">
          <strong>Email:</strong> {{ application.email || '/' }}
        </p>
        <p class="mb-1">
          <strong>Stylist account ID:</strong> {{ accountId }}
        </p>
        <p class="mb-1">
          <strong>Application ID (clicked row):</strong>
          {{ application.id || application._id }}
        </p>
        <p class="mt-4 mb-0 font-weight-medium">
          This will permanently delete:
        </p>
        <ul class="mt-1">
          <li>the stylist account</li>
          <li>all applications for this stylist</li>
          <li>the login (User) for this email</li>
          <li>stylist messages linked to this account</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="loading" @click="handleCancel">Cancel</v-btn>
        <v-btn color="error" :loading="loading" @click="$emit('confirm')">
          Delete permanently
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DeleteStylistConfirmDialog',
    props: {
      value: { type: Boolean, default: false },
      application: { type: Object, default: null },
      loading: { type: Boolean, default: false }
    },
    computed: {
      internalOpen: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      },
      accountId() {
        if (!this.application) return ''
        return (
          this.application.stylistId ||
          this.application.account?._id ||
          this.application.account ||
          ''
        )
      }
    },
    methods: {
      handleCancel() {
        if (this.loading) return
        this.$emit('input', false)
        this.$emit('cancel')
      }
    }
  }
</script>

<style scoped>
  .breakword {
    word-break: break-word;
  }
</style>
